(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealAll = () => {
      document.querySelectorAll('[data-animate]').forEach((el) => el.classList.add('is-visible'));
    };

    const initReveal = () => {
      const targets = document.querySelectorAll('[data-animate]:not(.is-visible)');
      if (!targets.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealAll();
        return;
      }

      const animationDistance = Math.max(
        0,
        Number.parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--animation-distance')
        ) || 0
      );

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: `0px 0px ${animationDistance}px 0px`,
          threshold: 0,
        }
      );

      targets.forEach((el) => observer.observe(el));
    };

    const initPastHero = () => {
      const hero = document.querySelector('[data-hero]');

      if (!hero || !('IntersectionObserver' in window)) {
        document.body.classList.add('is-past-hero');
        return;
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          document.body.classList.toggle('is-past-hero', !entry.isIntersecting);
        },
        { threshold: 0 }
      );

      observer.observe(hero);
    };

    const init = () => {
      initReveal();
      initPastHero();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // The theme editor swaps section markup without a page load.
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
